module.exports = __webpack_public_path__ + "img/00—01—Login—IB2.f6e24621.jpg";